module.exports = __webpack_public_path__ + "media/images/icons/outlined/ungroup-78e7bfd514e1f6ad37c6d70175daef38.svg";